<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="物件详情"
      width="80%"
      @close="close"
    >
      <el-row>
        <el-col :span="5">物件名称:</el-col>
        <el-col :span="19">{{ showForm.title }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">物件封面:</el-col>
        <el-col :span="19">
          <el-image
            :src="showForm.basic && showForm.basic.avatar"
            class="p-avatar"
          >
            <template v-slot:error class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </template>
          </el-image>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="5">标签:</el-col>
        <el-col :span="12">
          {{
            showForm.tags&&showForm.tags.map((item) => item.basic.title).join('/')
          }}
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="5">备注</el-col>
        <el-col :span="15">
          {{ showForm.basic && showForm.basic.text }}
        </el-col>
      </el-row>
      <!-- 媒体信息 -->
      <el-row>
        <el-col :span="5">媒体信息</el-col>
        <el-col :span="15">
          <el-result v-for="item of list" :key="item.mediumId" :subTitle="item.basic?.text">
            <template #icon>
              <el-image
                :src="item.basic?.imageUrl"
              ></el-image>
            </template>
          </el-result>
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { findItem, findMediumAll } from '@/api/mediaLibrary'
export default {
  name: 'ItemDetail',
  emits: ['fetch-data'],
  data() {
    return {
      showForm: {},
      list: [],
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const itemId = row.itemId
      const data = await findItem({
        itemId,
      })
      const media = await findMediumAll({ itemId })
      this.showForm = data
      this.list = media
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
